/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import type { IActiveUserProfile } from 'ajs/modules/core/services/active-user-profile';

/**
 * User Profile store state.
 */
export interface IUserProfileState {
    profile: IActiveUserProfile | undefined;
}

export const initialState: IUserProfileState = {
    profile: undefined,
};
